import { Injectable, Inject } from '@angular/core';
import { appHttpClient } from '@framework';
import { RoleModel } from '@models';
import { environment as env } from 'environments/environment';

@Injectable()
export class RoleServices {
    private get _endpoint() { return env.app_apiURL + '/roles' }

    constructor(@Inject('appHttpClient') private _httpClient: appHttpClient) { }

    Find(_role?: RoleModel) {
        let _endpoint = this._endpoint;
        if (_role) {
            _endpoint += '?' + _role.toQueryParamData();
        }
        return this._httpClient.Get(_endpoint)
            .map(res => res.json());
    }

 
};
